import { DqLoader } from "@decentriq/components";
import { Option, Select, type SelectProps, Stack, Typography } from "@mui/joy";
import { useLocalStorageState } from "ahooks";
import { memo, useCallback } from "react";
import { useOrganizationSelector } from "features/dmp";
import { portalTypeStorageKeyName } from "features/dmp/constants";
import { PortalType } from "features/dmp/types";
import { useUserRole } from "hooks";

const OrganizationSelector = memo(() => {
  const { isSuperAdmin, isLoading: isUserRoleLoading } = useUserRole();
  const [portalType] = useLocalStorageState<string>(portalTypeStorageKeyName, {
    defaultValue: PortalType.DCR,
    listenStorageChange: true,
  });
  const {
    organizations,
    isLoading: isOrganizationSelectorLoading,
    selectedOrganizationId,
    setSelectedOrganizationId,
  } = useOrganizationSelector();
  const handleChange = useCallback<
    NonNullable<SelectProps<string, false>["onChange"]>
  >(
    (event, newValue) => {
      if (newValue) {
        setSelectedOrganizationId(newValue);
      }
    },
    [setSelectedOrganizationId]
  );
  return (
    isSuperAdmin &&
    portalType === PortalType.PAP &&
    (isUserRoleLoading ? (
      <DqLoader />
    ) : organizations.length > 1 ? (
      <Stack alignItems="center" direction="row" spacing={1}>
        <Typography level="body-sm">Act as:</Typography>
        <Select
          disabled={isOrganizationSelectorLoading}
          onChange={handleChange}
          placeholder="Select organization"
          size="sm"
          startDecorator={
            isOrganizationSelectorLoading ? <DqLoader /> : undefined
          }
          sx={{ minWidth: 200 }}
          value={selectedOrganizationId}
        >
          {organizations.map((org) => (
            <Option key={org.id} value={org.id}>
              {org.name}
            </Option>
          ))}
        </Select>
      </Stack>
    ) : null)
  );
});
OrganizationSelector.displayName = "OrganizationSelector";

export default OrganizationSelector;
